import React, { Fragment, JSX } from "react";
import { Container, Typography } from "@mui/material";

type Props = {
  id: string;
  children: JSX.Element;
  title?: string;
  subtitle?: string;
};

function SectionContainer({ children, id, title, subtitle }: Props) {
  return (
    <Container
      id={id}
      sx={{ paddingTop: { xs: 2, sm: 4 }, height: "fit-content" }}
    >
      {title && !subtitle && (
        <Typography variant="h4" sx={{ marginBottom: 5 }}>
          {title}
        </Typography>
      )}
      {title && subtitle && (
        <Fragment>
          <Typography variant="h4">{title}</Typography>
          <Typography variant="h6" sx={{ marginBottom: 5 }}>
            {subtitle}
          </Typography>
        </Fragment>
      )}
      {children}
    </Container>
  );
}

export default SectionContainer;
